// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCEx5kbEpyymfbSe1wnXa3QcrpPvmf6dzY",
    authDomain: "aesthetics-map-dev-env.firebaseapp.com",
    projectId: "aesthetics-map-dev-env",
    storageBucket: "aesthetics-map-dev-env.appspot.com",
    messagingSenderId: "175955773310",
    appId: "1:175955773310:web:d91fa5536ad5998c67552f",
    measurementId: "G-H4545JRHJQ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
